export function getFirstSlideOnPageForIndex(index: number, slidesOnPage: number): number {
  return Math.floor(index / slidesOnPage) * slidesOnPage;
}
